<template>
	<input v-if="visible" type="radio" v-model="value" :value="rb.value" :class="clazz" :style="style" v-bind="tabindexBinding()" :disabled="ro"/>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "./Editor";
import type {Radio} from "@t/fd/editor/Radio";
import {computed} from "vue";

const uprops = defineProps({...editorProps});
const props = uprops as EditorProps;

const rb = computed<Radio>(() => props.part as Radio);
const {visible, value, clazz, style, ro, tabindexBinding} = useEditor(props);
</script>

<style>
.fd-radio {
	-webkit-appearance: none;
	-moz-appearance: none;
	background-color: var(--bg);
	border: none;
	outline: 0;
	margin: 0;
}

.fd-radio:checked {
	background-image: url(../assets/radio.svg);
}

.fd-radio:checked:disabled {
	background-image: url(../assets/radio-disabled.svg);
}

.fd-radio {
	width: 14px;
	height: 14px;
	border-radius: 7px;
	box-shadow: var(--input-shadow);
	line-height: var(--input-height);
	vertical-align: -1px;
	margin-top: calc((var(--input-height) - 1em) / 2);
}

@media (pointer: coarse) {
	.fd-radio {
		width: 22px;
		height: 22px;
		border-radius: 11px;
		vertical-align: -5px;
	}
}

</style>